'use client';

import { useEffect } from 'react';

import { useStore } from '@/entities/store';
import SignUp from '@/features/auth/sign-up/ui';
import { Layout } from '@/widgets/layout/ui';

export default function SignUpPage() {
  const { user } = useStore();

  useEffect(() => {
    if (user.isAuthorized) {
      user.logout();
    }
  }, [user]);

  return (
    <Layout>
      <SignUp />
    </Layout>
  );
}
